export const ru = {
    close: 'Закрыть',
    download: 'Скачать файл',
    'error-message': 'Произошла непредвиденная ошибка. Повторите попытку позже.',
    'export-to-excel': 'Экспорт в Excel',
    'pay-not-allowed-cpm':
        'Для оплаты медийных кампаний необходимо выставить отдельный счет. Оплата вместе с другими кампаниями недоступна.',
    'pay-not-allowed-deals':
        'Для оплаты кампаний со сделками необходимо выставить отдельный счет. Оплата вместе с кампаниями без сделок недоступна.'
};
